import type { Components } from '@mui/material';
import type { Theme } from '@mui/material/styles';

export const MuiListItemIcon: Components<Omit<Theme, 'components'>>['MuiListItemIcon'] = {
  defaultProps: {
    sx: {
      minWidth: '48px',
    },
  },
};
